export default "__VITE_ASSET__03959010__"